// extracted by mini-css-extract-plugin
export default {"MatchBadge":"sEibpo","matchBadge":"sEibpo","MatchBadgeOptimizedAlt":"fBgHw0","matchBadgeOptimizedAlt":"fBgHw0"};